export default __webpack_public_path__ + "static/sebastian-andil-2fe9322706c86d9ccea2c3a20cfa6dba.jpg";